// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrTwL_gRYeEGqzliTX2W{z-index:var(--zIndex-OVERLAY_MAIN);background-color:rgba(20,22,26,.5);position:absolute;top:0;bottom:0;left:0;right:0;overflow:auto}.hTSoDS_kcqkmYJxFLNuk,.Wz3HtEe9v_ckRxqQvD1b{z-index:var(--zIndex-OVERLAY_MAIN_2);position:fixed;top:50%;transform:translateY(-50%)}.hTSoDS_kcqkmYJxFLNuk{left:32px}.Wz3HtEe9v_ckRxqQvD1b{right:32px}.zONIpc6ioI8uz05vuHUD{z-index:var(--zIndex-OVERLAY_MAIN_2);position:fixed;top:24px;right:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BrTwL_gRYeEGqzliTX2W`,
	"leftArrow": `hTSoDS_kcqkmYJxFLNuk`,
	"rightArrow": `Wz3HtEe9v_ckRxqQvD1b`,
	"closeButton": `zONIpc6ioI8uz05vuHUD`
};
export default ___CSS_LOADER_EXPORT___;
